module.exports = __webpack_public_path__ + "img/icon_fengsu.ac61a0ae.png";